export default __webpack_public_path__ + "static/jobs-1a437589607eaf04acf0f389dcb6c145.jpg";